module.exports = __webpack_public_path__ + "static/media/휴거-1992.29b9f44a.png";